module.exports = new __parcel__URL__("bossfight_divider.214a95e2.png").toString();